import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./components/homePage.js";
import DetailPage from "./components/detailPage.js";
import Testing from "./components/testing";

// Change URL to get data from PROD or PRE...
const baseApiUrl = "https://scrmprox.museunacional.cat";
// const baseApiUrl = "https://scrmprox-pre.museunacional.cat";

const App = () => {
  return (
      <BrowserRouter>
        <Routes>
          <Route path="/detail/:uri" element={<DetailPage baseApiUrl={baseApiUrl}/>} />
          <Route path="/*" element={<HomePage baseApiUrl={baseApiUrl}/>} />
          <Route path="/testing" element={<Testing baseApiUrl={baseApiUrl}/>} />
        </Routes>
      </BrowserRouter>
  );
};
export default App;
